export var PermissionCategory;
(function (PermissionCategory) {
    PermissionCategory["PERMISSION_CATEGORY_GLOBAL_MANAGEMENT"] = "GLOBAL_MANAGEMENT";
    PermissionCategory["PERMISSION_CATEGORY_VIEWING"] = "VIEWING";
    PermissionCategory["PERMISSION_CATEGORY_OPERATION"] = "OPERATION";
    PermissionCategory["PERMISSION_CATEGORY_ADMINISTRATION"] = "ADMINISTRATION";
})(PermissionCategory || (PermissionCategory = {}));
